import React, { useState } from 'react';
import PdfCertModal from '../pdf';
import dokuCSS from './docuHistory.module.css';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import ChecklistModal from '../checklistModal';
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

export function DocumentationHistory({ documentation }) {
  console.log('Documentation:', documentation);

  const executedServices = documentation.orderedProduct.data.attributes.executed_services.data || [];
  const historicalDocumentation = documentation.orderedProduct.data.attributes.historical_documentations ? documentation.orderedProduct.data.attributes.historical_documentations.data : [];

  const attributes = documentation.orderedProduct.data.attributes;
  const product = attributes.product.data.attributes;
  const customer = attributes.customer.data.attributes;
  const serviceInfo = attributes?.executed_services?.data[0]?.attributes?.service_info;
  const serialNumber = attributes?.serial_number;
  const serviceComment = attributes?.executed_services?.data[0]?.attributes?.comment;

  console.log('Historical Documentation:', historicalDocumentation);

  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (id) => {
      setOpenDropdowns(prevState => ({
          ...prevState,
          [id]: !prevState[id]
      }));
  };

  const handleShowCertificate = (items) => {
      setSelectedItems(items);
      setModalTitle('Sertifikat');
      setShowCertificateModal(true);
  };

  const handleShowChecklist = (items) => {
      setSelectedItems(items);
      setModalTitle('Sjekkliste');
      setShowChecklistModal(true);
  };

  const handleCloseCertificateModal = () => setShowCertificateModal(false);
  const handleCloseChecklistModal = () => setShowChecklistModal(false);

  const renderExecutedServices = (services) => {
      return services.map(service => {
          const year = service.attributes.year || 'Ukjent år';
          const isOpen = openDropdowns[service.id] || false;
          return (
              <div className={dokuCSS.container10} key={`executed-${service.id}`}>
                  <button className={`${dokuCSS.ddTrigger2}`} onClick={() => toggleDropdown(service.id)}>
                      {year}
                  </button>
                  <div className={`${dokuCSS.ddContent} ${isOpen ? dokuCSS.active : ''}`}>
                      <PdfCertModal
                          buttonTitle="Sertifikat"
                          modalTitle={`${year} Sertifikat`}
                          object={documentation}
                          year={year}
                          closeButtonClass="button"
                          openButtonClass={dokuCSS.button}
                      />
                      <ChecklistModal
                            buttonTitle="Sjekkliste"
                            modalTitle={`${year} Sjekkliste`}
                            serviceChecks={service.attributes.service_checks.data}
                            openButtonClass={dokuCSS.button}
                            closeButtonClass="button"
                            product={product}
                            customer={customer}
                            serviceInfo={serviceInfo}
                            serial={serialNumber}
                            comment={serviceComment}
                        />
                  </div>
              </div>
          );
      });
  };

  const renderHistoricalDocumentation = (docs) => {
    if (docs.length === 0) {
        return <p></p>;
    }

    return docs.map(doc => {
        const year = doc?.attributes?.year || 'Ukjent år';
        const isOpen = openDropdowns[doc.id] || false;

        if (year === 'Ukjent år') {
            return (
                <div className={dokuCSS.container10} key={`historical-${doc.id}`}>
                    <p></p>
                </div>
            );
        }

        const hasCertificates = doc.attributes.certificates.data.length > 0;
        const hasSkjemaer = doc.attributes.skjemaer.data.length > 0;

        return (
            <div className={dokuCSS.container10} key={`historical-${doc.id}`}>
                <button className={dokuCSS.ddTrigger2} onClick={() => toggleDropdown(doc.id)}>
                    {year}
                </button>
                <div className={`${dokuCSS.ddContent} ${isOpen ? dokuCSS.active : ''}`}>
                    {hasCertificates && (
                        <button className={dokuCSS.button} onClick={() => handleShowCertificate(doc.attributes.certificates.data)}>
                            Sertifikat
                        </button>
                    )}
                    {hasSkjemaer && (
                        <button className={dokuCSS.button} onClick={() => handleShowChecklist(doc.attributes.skjemaer.data)}>
                            Sjekkliste
                        </button>
                    )}
                </div>
            </div>
        );
    });
};

const renderFile = (item) => {
  const fileUrl = item.attributes.url;
  const fileType = fileUrl.split('.').pop().toLowerCase();

if(fileType === 'pdf') {
    return <>
        <iframe 
            src={`${fileUrl}#page=1`}
            style={{ width: '100%', height: '500px', border: 'none', overflow: 'hidden' }}
            title="PDF Thumbnail"
            className="m-auto"
        />
    </>
} else {
    return <img src={fileUrl} alt="Document" style={{ width: '100%' }} />
}
}

  return (
      <div>
          {renderExecutedServices(executedServices)}
          {renderHistoricalDocumentation(historicalDocumentation)}

          <Modal show={showCertificateModal} onHide={handleCloseCertificateModal}>
              <Modal.Header closeButton>
                  <Modal.Title>{modalTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              {selectedItems && selectedItems.length > 1 ? (
                        <Carousel>
                            {selectedItems.map(item => (
                                <Carousel.Item key={item.id}>
                                    {renderFile(item)}
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : (
                        selectedItems.map(item => (
                            <div key={item.id}>
                                {renderFile(item)}
                            </div>
                        ))
                    )}
              </Modal.Body>
              <Modal.Footer>
                  <button variant="secondary" onClick={handleCloseCertificateModal}>
                      Lukk
                  </button>
              </Modal.Footer>
          </Modal>

          <Modal show={showChecklistModal} onHide={handleCloseChecklistModal}>
              <Modal.Header closeButton>
                  <Modal.Title>{modalTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              {selectedItems && selectedItems.length > 1 ? (
                        <Carousel>
                            {selectedItems.map(item => (
                                <Carousel.Item key={item.id}>
                                    {renderFile(item)}
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : (
                        selectedItems.map(item => (
                            <div key={item.id}>
                                {renderFile(item)}
                            </div>
                        ))
                    )}
              </Modal.Body>
              <Modal.Footer>
                  <button variant="secondary" onClick={handleCloseChecklistModal}>
                      Lukk
                  </button>
              </Modal.Footer>
          </Modal>
      </div>
  );
}

export default DocumentationHistory;